export const CLIENT_HEADER = 'X-Client';
export const TENANT_HEADER = 'X-Tenant';

type GlobalHeaders = Record<string, string>;

const globalHeaders: GlobalHeaders = {};

export function getGlobalHeaders(): GlobalHeaders {
  return { ...globalHeaders };
}

export function setAuthHeader(token: string): void {
  globalHeaders['Authorization'] = `Bearer ${token}`;
}

export function clearAuthHeader(): void {
  delete globalHeaders['Authorization'];
}

export function setUserHeader(email: string): void {
  globalHeaders['x-user'] = email;
}

export function clearUserHeader(): void {
  delete globalHeaders['x-user'];
}

export function setClientHeader(client: string): void {
  globalHeaders[CLIENT_HEADER] = client;
}

export function clearClientHeader(): void {
  delete globalHeaders[CLIENT_HEADER];
}

export function setTenantHeader(tenant: string): void {
  globalHeaders[TENANT_HEADER] = tenant;
}

export function clearTenantHeader(): void {
  delete globalHeaders[TENANT_HEADER];
}

export function setE2ETransactionIdHeader(transactionId: string): void {
  globalHeaders['x-e2e-transaction-id'] = transactionId;
}

export function clearE2ETransactionIdHeader(): void {
  delete globalHeaders['x-e2e-transaction-id'];
}
